const config = {
  imbyUrl: "https://experience.geowebonline.nl/GeoWeb56/index.html?viewer=IMBY_Bunnik",
  informatiebijeenkomstUrl: "https://forms.office.com/Pages/ResponsePage.aspx?id=8C6HtwCaGEyKSsfSXHeKnvlM6t6C7-xIrBy1eQVPTN1UM05OMDhYNU1MOENFWUEwSVFVRDdVVkpRMS4u",
  navBarItems: [
    {
      text: "Over het project",
       id: "info-text-expanded"
    },
    {
        text: "Contact",
        id: "contact-info"
    }
],
    callToAction: {
        titleShortText: "In het kort...",
        titleExtendedText: "Fietsroute",
        subTitleExtendedText: "",
        shortText: `De provincie Utrecht en de gemeenten Utrecht, Bunnik, Rhenen, Utrechtse Heuvelrug en Veenendaal en de Universiteit Utrecht werken samen aan een plan voor het verbeteren van een doorgaande fietsroute tussen Veenendaal en Utrecht Science Park. Deze route loopt in Bunnik via de parallelwegen van de Provincialeweg (kruising Van Zijldreef), Stationsweg en Schoudermantel tot de komgrens. We vinden het belangrijk om te horen wat de gebruikers, bewoners en bedrijven langs de route van dit ontwerp vinden. Dat helpt ons om de plannen verder uit te werken en te verbeteren. U kunt op de interactieve kaart aangeven wat u belangrijk vindt, wat uw zorgen en uw wensen zijn.

`,
        responseDate: "Reageren kan van maandag 15 maart tot en met zondag 28 maart. Op maandagavond 22 maart is er van 19.30 tot 20.30u een digitale informatiebijeenkomst via Zoom. Hier geven we een toelichting en kunt u via de chat uw vragen stellen. Aanmelden kan via de link onder aan de pagina. ", 
        extendedTextParagraphs: [
                {
                id: "extended-text-paragraph-2",
                title: "Fietsroute",
                text: `Het doel van de nieuwe fietsroute is om meer ruimte te bieden aan fietsers. Tegelijk zorgen we voor meer veiligheid en comfort op de fietsroute. Over de hele route willen we maatregelen nemen zoals het verbreden van fietspaden, het aanleggen van fietsstraten waar de auto te gast is, het weghalen van overbodige paaltjes, het vloeiender maken van bochten en meer voorrang geven aan fietsers. Hiermee wordt het aantrekkelijker om ook over grotere afstanden de (elektrische) fiets te gebruiken. En dat is goed voor de bereikbaarheid van onze provincie.`,
                highlightText: 'Klik op “start nu” om het ontwerp te bekijken en opmerkingen te plaatsen. Voor het plaatsen van opmerkingen kunt u het beste de website openen via uw laptop, pc of tablet. Hierdoor gaan er geen functionaliteiten verloren.'
        },
        {
                id: "extended-text-paragraph-3",
                title: "Randvoorwaarden ontwerp",
                text: `Wij hebben voor de route via de Provincialeweg, Stationsweg en Schoudermantel een eerste ontwerp gemaakt (het concept Voorlopig Ontwerp). Hiermee geven we op hoofdlijnen aan hoe volgens ons de fietsroute eruit kan komen te zien. Hoe de route loopt en sommige elementen voor de inrichting van de fietsroute, liggen vast. Dit komt op het volgende neer:
•	De herinrichting gebeurt tussen de erfgrens en de groenstrook met heggen en bomen. Heggen en bomen blijven overal behouden;
•	De parallelweg wordt een fietsstraat, met auto te gast. Voor auto’s eenrichtingsverkeer, voor fietsers in twee richtingen;
•	De rijbaan van de fietsstraat wordt 3,50 m breed, uitgevoerd in rood asfalt. 
•	Waar nu een voetpad ontbreekt (grotendeels tussen de Van Zijldreef en de Smalleweg), wordt een trottoir aangelegd. Dat wordt in tegels uitgevoerd en circa 1,50 m breed;
•	De scheiding tussen fietsstraat en voetpad wordt uitgevoerd met een lage, schuine band;
•	Er is voor het grootste deel van de route geen ruimte voor een afzonderlijke parkeerstrook.`,
        },
        {
            id: "extended-text-paragraph-4",
            title: "Parkeren",
            text: `Het langsparkeren van auto’s op de snelfietsroute verhoogt het risico op ongelukken. Dat willen we voorkomen en daarom wordt parkeren op straat (en het trottoir) verboden. Wij beseffen dat het vervallen van de parkeermogelijkheid veel impact heeft voor aanwonenden. Parkeren zal in de toekomst alleen op eigen erf kunnen of anders verderop in de omgeving. Voor woningen zonder eigen oprit wordt een afzonderlijke oplossing gezocht, zodat ook voor die adressen parkeren nabij de woning mogelijk blijft.`,
            highlightText: ''
        },
        {
            id: "extended-text-paragraph-5",
            title: "Wat is het vervolg?",
            text: `Uw reactie blijft voor anderen anoniem. Alle reacties op het concept Voorlopig Ontwerp verzamelen wij. In een werkgroep waaraan de provincie en de gemeenten deelnemen, wordt alle inbreng besproken en van een reactie voorzien. Voor het deel van de snelfietsroute dat langs de Oranjebuurt loopt, wordt ook het Programma van Eisen Herinrichting Oranjebuurt langs het ontwerp gelegd. De inbreng kan leiden tot wijzigingen in het concept Voorlopig Ontwerp. Alle vragen, opmerkingen, suggesties en onze reacties daarop, zullen verschijnen in een reactienota. Iedereen die heeft gereageerd krijgt deze toegestuurd zodat u antwoord krijgt op uw vragen en weet wat wij met uw inbreng doen. Ook zal de reactienota te lezen zijn op de provinciale website over de snelfietsroutes.`,
            highlightText: ''
        },
        {
            id: "extended-text-paragraph-6",
            title: "Planning",
            text: `De uitvoering van de werkzaamheden staat voorlopig gepland voor 2022-2023. Voor de parallelweg van de Stationsweg loopt dit mogelijk gelijk op met de uitvoering van de herinrichting van de Oranjebuurt. De werkzaamheden zullen op elkaar afgestemd worden.`,
            highlightText: ''
        }            
    ]
    },
    visualization:{
        title: "",        
        text: ""
    }
    ,
    contactInfos:[
        {
            supportiveText: "Voor inhoudelijke vragen",
            name: "Paul van Weenen",
            telephoneNumber: "T +31 (06) 527 69 469"
        },
        {
            supportiveText: "Voor technische vragen",
            name: "Emma de Bruijn",
            telephoneNumber: "T +31 (0)6 204 27 320"
        }        
    ]
};

export default config;